"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscriptionPlanProvider = exports.isSubscriptionPlan = exports.SubscriptionProviderSchema = exports.SubscriptionProviderEnum = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
// ENUMS
var SubscriptionProviderEnum;
(function (SubscriptionProviderEnum) {
    SubscriptionProviderEnum["Chargebee"] = "chargebee";
    SubscriptionProviderEnum["iOS"] = "ios";
    SubscriptionProviderEnum["Android"] = "android";
})(SubscriptionProviderEnum = exports.SubscriptionProviderEnum || (exports.SubscriptionProviderEnum = {}));
// SCHEMAS
exports.SubscriptionProviderSchema = zod_1.z.nativeEnum(SubscriptionProviderEnum);
const SubscriptionPlanSchema = zod_1.z.object({
    description: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    isBacker: zod_1.z.boolean(),
    isRefundable: zod_1.z.boolean(),
    name: zod_1.z.string(),
    provider: exports.SubscriptionProviderSchema,
    status: zod_1.z.boolean(),
    termDuration: zod_1.z.number().optional(),
});
// TYPE GUARDS
exports.isSubscriptionPlan = type_validation_helpers_1.getVerboseTypeValidationFunction(SubscriptionPlanSchema);
exports.isSubscriptionPlanProvider = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.SubscriptionProviderSchema);
//# sourceMappingURL=subscription_plan_types.js.map